import { CHECK_LAST_ROUTE_REQUEST, CHECK_LAST_ROUTE_REQUEST_FAILURE } from '../constants/check_last_route_and_permission.constants';

export const checkLastRouteRequest = route => ({ type: CHECK_LAST_ROUTE_REQUEST, route });
export const checkLastRouteRequestFailure = error => ({ type: CHECK_LAST_ROUTE_REQUEST_FAILURE, error });



// WEBPACK FOOTER //
// ./src/modules/App/redux/actions/check_last_route.actions.js